exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".export-steps-container .export-steps {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 20px 50px; }\n  .export-steps-container .export-steps > div, .export-steps-container .export-steps .fa-chevron-right {\n    color: #adb5bd; }\n    .export-steps-container .export-steps > div.active, .export-steps-container .export-steps .fa-chevron-right.active {\n      color: #333 !important;\n      font-size: 1.2rem; }\n", ""]);

// exports
